import { DefaultTableTypeAbstract } from "./DefaultTableTypeAbstract";

export class DefaultTableTypeStandard extends DefaultTableTypeAbstract {
}
